<template>
 <router-view/>
</template>


<script>
import axios from 'axios';
// import IconConverter from '@/components/converters/IconConverter.vue';
// import SignsAllIconsDisplayer from '@/components/views/SignsAllIconsDisplayer.vue';


export default {
  data() {
    return {
      info: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },

  methods: {
    fetchData(){
      //get zodiac data
      axios.get(this.baseUrl).then(response => {
      // axios.get(this.baseUrl + 'BOSSignProfiles.json').then(response => {
          this.info = response.data;
          let signName = this.info.signs["1"].signName;
          // console.log("info is", this.info.signs["1"].signName);
          // console.log("info is", signName);
          this.$store.dispatch('loadZodiacData', signName);
          return this.info;
      }).catch((e) => {
      console.error('error getting zodiac sign names: ', e)
    })
    },
    // loadContent: function (detailIdIs){ 
		// let detailId = detailIdIs;
		// console.log('load content', detailId);
		// this.$store.dispatch('loadZodiacData', detailId);
		// },	
  },
  created(){
    // Fetch Data
    this.fetchData();
}
  // components: {
  //   IconConverter,
  //   SignsAllIconsDisplayer
  // }
};



</script>



<style >
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
	body {
		margin: 0;
		padding: 0;
		border: 0;
	}
.inline {
  position:relative;
  display: inline-flex;
  padding: 5px;
  margin: 5px;
  background-color: lightseagreen;
  }
div {
  display: unset;
}
</style>
